import { FormProvider as RHFFormProvider } from "react-hook-form";
import { Box } from "@mui/material";

const FormProvider = ({ children, methods, onSubmit, ...boxProps }) => {
  return (
    <RHFFormProvider {...methods}>
      <Box
        component="form"
        onSubmit={onSubmit ? methods.handleSubmit(onSubmit) : undefined}
        noValidate
        {...boxProps}
      >
        {children}
      </Box>
    </RHFFormProvider>
  );
};

export default FormProvider;
